import { Reveal } from "../Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLang } from "../../context/LanguageContext";

export function ProgramAccordion({ program = [] }) {
  const { t } = useLang();
  if (!program.length) return null;
  return (
    <section data-testid="course-program" className="bg-[#F4F8FF] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1100px] mx-auto">
        <Reveal className="mb-12">
          <span className="overline">{t("program.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3">
            {t("program.title")}
          </h2>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible defaultValue="day-0" className="w-full">
            {program.map((day, i) => (
              <AccordionItem key={i} value={`day-${i}`} className="border-b border-[#D5DEEE]" data-testid={`program-day-${i}`}>
                <AccordionTrigger className="py-6 hover:no-underline group text-left">
                  <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 pr-4">
                    <span className="font-heading text-xl md:text-2xl text-[#0B1220] group-hover:text-[#1452F0] transition-colors">
                      {day.title}
                    </span>
                    {day.time && <span className="text-sm text-[#5C6678] font-mono-ibn">{day.time}</span>}
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-8">
                  {day.topics && (
                    <div className="mb-4">
                      <span className="overline block mb-2">{t("program.topics")}</span>
                      <p className="text-[#0B1220]/80 font-light leading-relaxed text-base">{day.topics}</p>
                    </div>
                  )}
                  {day.practice && (
                    <div className="bg-[#E9EFFA] rounded-sm p-5 border-l-2 border-[#1452F0]">
                      <span className="overline block mb-2">{t("program.practice")}</span>
                      <p className="text-[#0B1220]/80 font-light leading-relaxed text-base">{day.practice}</p>
                    </div>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
